import { QueueKey } from 'flow/types/EntityKeys';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectQueueIsOfTypeCentionOmni } from 'flow/selectors/queue-selectors';
import EmptyStateQueueItemsOngoing from './EmptyStateQueueItemsOngoing';
import OngoingQueueCalls from './OngoingQueueCalls';
import OngoingCentionErrands from './OngoingCentionErrands';

interface Props {
    queueKey: QueueKey;
}

const QueueItemsOngoing = ({ queueKey }: Props) => {
    const queueIsOfTypeCentionOmni = useAppSelector((state) =>
        selectQueueIsOfTypeCentionOmni(state, queueKey),
    );
    return (
        <>
            <OngoingQueueCalls queueKey={queueKey} />
            {queueIsOfTypeCentionOmni && (
                <OngoingCentionErrands queueKey={queueKey} />
            )}
            <EmptyStateQueueItemsOngoing queueKey={queueKey} />
        </>
    );
};

export default QueueItemsOngoing;
